import Clarity from "@microsoft/clarity";
import { useMatches } from "@tanstack/react-router";
import { useEffect } from "react";

const ROUTE_ID_TO_PAGE_TYPE: Record<string, string> = {
  "/home": "home",
  "/plants": "plants",
  "/plants/$plantId/": "devices",
  "/plants/$plantId/dashboard": "dashboard",
  "/plants/$plantId/analysis": "analysis",
  "/plants/$plantId/performance": "performance",
  "/plants/$plantId/ncu/$ncuName": "ncu_detail",
  "/plants/$plantId/ncu/$ncuName/tcu/$tcuName": "tcu_detail",
  "/plants/$plantId/ncu/$ncuName/hsu/$hsuName": "hsu_detail",
  "/documentation": "documentation",
};

const routeIdToPageType = (routeId: string): string | null =>
  ROUTE_ID_TO_PAGE_TYPE[routeId] ?? null;

export const trackPageType = (value: string): void => {
  if (!import.meta.env.VITE_CLARITY_PROJECT_ID) {
    return;
  }
  Clarity.setTag("page_type", value);
};

export const useClarityPageType = () => {
  const matches = useMatches();
  const leafRouteId = matches[matches.length - 1]?.routeId;

  useEffect(() => {
    if (!leafRouteId) {
      return;
    }
    const pageType = routeIdToPageType(leafRouteId);
    if (pageType) {
      trackPageType(pageType);
    }
  }, [leafRouteId]);
};
